export default __webpack_public_path__ + "static/media/career-img-1.44663a18.png";